var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabTemperature = function SvgTabTemperature(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8091",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8710",
    d: "M15 17.156c-3.418.7-6 3.72-6 7.344a7.5 7.5 0 0 0 15 0c0-3.625-2.582-6.645-6-7.344v2.063c2.302.657 4 2.768 4 5.28a5.5 5.5 0 1 1-11 0c0-2.512 1.698-4.623 4-5.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8716",
    d: "M4.469 22.078a3.047 3.11 0 1 1-6.094 0 3.047 3.11 0 1 1 6.094 0",
    transform: "matrix(1.2308 0 0 1.206 14.75 -2.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8730",
    d: "M13 3.5V18h2V3.5zm5 0V18h2V3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8734",
    d: "M16 11h1v12h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8756",
    d: "M16.5 0A3.5 3.5 0 0 0 13 3.5c0 1.4.813 2.596 2 3.156V3.5a1.5 1.5 0 1 1 3 0v3.156c1.187-.56 2-1.757 2-3.156A3.5 3.5 0 0 0 16.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8791",
    d: "M8 3h4v1H8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8821",
    d: "M10 6h2v1h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8823",
    d: "M8 9h4v1H8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8825",
    d: "M10 12h2v1h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect8827",
    d: "M8 15h4v1H8z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabTemperature);
export default ForwardRef;